import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Link } from 'react-router-dom';

/**
 * Markdown renderer per messaggi AI stile ChatGPT.
 * Supporta: titoli, grassetto, corsivo, liste, blockquote, codice inline e blocchi.
 */
export default function MarkdownMessage({ content, dark = false }) {
  const proseCls = dark
    ? 'prose prose-invert prose-sm max-w-none'
    : 'prose prose-sm dark:prose-invert max-w-none text-current prose-headings:text-current prose-strong:text-current prose-a:text-green-700 dark:prose-a:text-chartreuse prose-th:text-current';
  return (
    <div className={proseCls}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="font-display text-xl mt-3 mb-2" {...p}/>,
          h2: (p) => <h2 className="font-display text-lg mt-3 mb-2" {...p}/>,
          h3: (p) => <h3 className="font-display text-base mt-3 mb-1.5" {...p}/>,
          p: (p) => <p className="my-2 leading-relaxed" {...p}/>,
          ul: (p) => <ul className="list-disc pl-5 my-2 space-y-1" {...p}/>,
          ol: (p) => <ol className="list-decimal pl-5 my-2 space-y-1" {...p}/>,
          li: (p) => <li className="leading-relaxed" {...p}/>,
          strong: (p) => <strong className="font-semibold" {...p}/>,
          em: (p) => <em className="italic" {...p}/>,
          blockquote: (p) => <blockquote className={`border-l-2 ${dark?'border-background/40':'border-border'} pl-3 my-2 italic opacity-80`} {...p}/>,
          code: ({inline, children, ...props}) => inline
            ? <code className={`px-1.5 py-0.5 rounded text-[0.85em] ${dark?'bg-background/20':'bg-secondary'}`} {...props}>{children}</code>
            : <code className={`block p-3 rounded-lg overflow-x-auto text-[0.85em] my-2 ${dark?'bg-background/20':'bg-secondary'}`} {...props}>{children}</code>,
          a: ({ href = '', node, ...p }) => (href.startsWith('/')
            ? <Link to={href} className="underline underline-offset-2 hover:opacity-80" {...p}/>
            : <a href={href} className="underline underline-offset-2 hover:opacity-80" target="_blank" rel="noreferrer" {...p}/>),
          hr: () => <hr className="my-3 opacity-30"/>,
          table: (p) => <div className="overflow-x-auto my-2"><table className="text-sm" {...p}/></div>,
          th: (p) => <th className="px-2 py-1 border-b border-border text-left font-semibold" {...p}/>,
          td: (p) => <td className="px-2 py-1 border-b border-border/50" {...p}/>,
        }}
      >
        {content || ''}
      </ReactMarkdown>
    </div>
  );
}
